export default "__VITE_ASSET__319ac88f__"